import { Fragment } from 'react';
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth/AuthProvider';
import { UnsavedProvider, useLeaveGuard } from './adminUtil';

type Item = { to: string; label: string };

export function AdminLayout() {
  return (
    <UnsavedProvider>
      <AdminLayoutInner />
    </UnsavedProvider>
  );
}

/** Reiter nach Häufigkeit geordnet, in drei Gruppen: Zugriff, Inhalte, Daten */
function AdminLayoutInner() {
  const { can } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const guard = useLeaveGuard();
  const groups: Item[][] = [
    [can('users') && { to: 'nutzer', label: 'Nutzer' }, can('users') && { to: 'rollen', label: 'Rollen und Rechte' }],
    [
      can('templates') && { to: 'vorlagen', label: 'Vorlagen' },
      can('settings') && { to: 'checkliste', label: 'Checklisten-Vorlage' },
      can('settings') && { to: 'kontaktkategorien', label: 'Kontaktkategorien' },
      can('settings') && { to: 'stammlisten', label: 'Stammlisten' },
      can('settings') && { to: 'einstellungen', label: 'Einstellungen' },
    ],
    [can('import') && { to: 'import', label: 'Import' }, can('export') && { to: 'export', label: 'Export' }, can('audit') && { to: 'protokoll', label: 'Protokoll' }],
  ]
    .map((g) => g.filter(Boolean) as Item[])
    .filter((g) => g.length);
  return (
    <>
      <div className="head">
        <div>
          <h1>Verwaltung</h1>
        </div>
      </div>
      <nav className="nav-tabs admin-tabs" aria-label="Verwaltung">
        {groups.map((g, gi) => (
          <Fragment key={gi}>
            {gi > 0 && <span className="sep" aria-hidden="true" />}
            {g.map((i) => (
              <NavLink
                key={i.to}
                to={i.to}
                className={({ isActive }) => (isActive ? 'active' : '')}
                onClick={(e) => {
                  if (loc.pathname.endsWith(`/${i.to}`) || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
                  e.preventDefault();
                  guard(() => nav(`/verwaltung/${i.to}`));
                }}
              >
                {i.label}
              </NavLink>
            ))}
          </Fragment>
        ))}
      </nav>
      <Outlet />
    </>
  );
}
